import {HookClass, Hook, BaseHook, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {Observable,Observer, of} from 'rxjs';
import {xml2json, json2xml} from 'xml-js';
import {map} from 'rxjs/operators';

@HookClass('xml')
export class XmlHook extends BaseHook {

    @Hook('a4557a36-ebea-4a3d-8fe9-98538ebf8668')
    public xml2Json(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
            return new Observable<any>((observer: Observer<any>) => {
                outputArtifact.kind = ArtfactKind.ANY;
                try {
                    const isBuffer = inputArtifact.object.xml instanceof Buffer;
                    const chunks: any[] = [];
                    let resultString = '';
                    if (isBuffer) {
                        outputArtifact.object = JSON.parse(xml2json(inputArtifact.object.xml.toString(), inputArtifact.object.config));
                        observer.next(outputArtifact);
                        observer.complete();

                    } else {
                        const reader = inputArtifact.object.xml;
                        reader.on('data', (buf: any) => chunks.push(buf));
                        reader.on('end', () => {
                            resultString = Buffer.concat(chunks).toString();
                            outputArtifact.object = JSON.parse(xml2json(resultString, inputArtifact.object.config));
                            observer.next(outputArtifact);
                            observer.complete();
                        });

                    }

                } catch (e) {
                    console.log('Error to parse xml.');
                    // throw new Error('Error to parse xml.');
                }
                // return of(outputArtifact);
            });
    }

    @Hook('c527afea-1e75-4d69-b031-c82995271e4c')
    public json2Xml(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return of(inputArtifact)
            .pipe(map(() => {
                const outputArtifact = new NickProcessArtfact();
                outputArtifact.kind = ArtfactKind.ANY;
                try {
                    outputArtifact.object = json2xml(inputArtifact.object.data, inputArtifact.object.config);
                } catch (e) {
                    throw new Error('Error to parse xml.');
                }
                return outputArtifact;
            }));
    }
}
